import { EndorsementKey, type EndorsementConfig } from '../../types';
import { selectCheckedEndorsements, selectLimitDamagePremRented } from '../../../../selectors/application';

export const config: EndorsementConfig = {
  endorsementKey: EndorsementKey.LimitDamagePremRented,
  label: 'Damages to Premises Rented to You (Higher Limits)',
  description:
    'Your policy includes $50,000 coverage for premises rented. Do you want to increase your total damage protection?',
  recommended: false,
};

export const isDamagesToPremisesRentedValid = (state: ReduxState) => {
  const isChecked = selectCheckedEndorsements(state).includes(EndorsementKey.LimitDamagePremRented);
  if (!isChecked) return true;
  const value = selectLimitDamagePremRented(state);
  if (!value) return false;
  return value >= 50_000 && value <= 1_000_000;
};
